var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormOrientation" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.redicetFormAnswer"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("form.redicetFormAnswerDesc")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "left" }, [
        _c("i", { staticClass: "md-icon" }, [_vm._v("confirmation_number")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("form.rediectAnswersToTicket")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("label", { staticClass: "switch" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ticketMode,
                expression: "ticketMode",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.ticketMode)
                ? _vm._i(_vm.ticketMode, null) > -1
                : _vm.ticketMode,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.ticketMode,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.ticketMode = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.ticketMode = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.ticketMode = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "slider round" }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("confirmation_number")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }